/**
 * Area specialized in displaying Book pages
 */
fx.ns("shared.stage", class BookArea extends shared.stage.Area {
    constructor(page, model, parentContainer, side, preview, options) {
        super(page, model, parentContainer, side, preview);

        this.LOSTBORDER = 5;

        this._activeSide = "";
        this._activePart = "";

        this._labelStyle = (options && options.labelStyle !== undefined) ? options.labelStyle : "single";
        this._layoutAuto = (options && options.layoutAuto !== undefined) ? options.layoutAuto : true;

        this.listenUpdates(page.components, true);
        this.listenUpdates(this.book, true);
    }

    /***************** Getters / Setters *****************/

    // Declared in constructor, trick for old browsers
    //static LOSTBORDER = 5;

    get page() {
        return this.element;
    }

    set page(val) {
        super.element = val;
    }

    get pageWidth() {
        return this.realWidth / 2;
    }

    get pageHeight() {
        return this.realHeight;
    }

    get dragActive() {
        return this._dragActive;
    }

    set dragActive(val) {
        this._dragActive = val;
    }


    get active() {
        return this._active;
    }

    set active(val) {
        this._active = val;

        if (val)
            this.addClass("active");
        else
            this.removeClass("active");
    }

    // return active part of pages : left / right / center (for slice)
    get activePart() {
        return this._activePart;
    }

    set activePart(val) {
        if (!this.initialized)
            return;

        if (this.displayedSide) {
            if (this.displayedSide == "right") {
                if (val == "left")
                    return;
            }
            if (this.displayedSide == "left") {
                if (val == "right")
                    return;
            }
        }

        // backcover should never be set as active part.
        if ((val == "left" && this.data.isFirstPage) || (val == "right" && this.data.isLastPage))
            val = "";

        this._activePart = val;
        this.activeSide = (val == "center") ? this.displayedSide : val;

        if (!this.loaded) return;

        if (this.backgroundLeft)
            this.backgroundLeft.toggleClass("active", val == "left");

        if (this.backgroundRight)
            this.backgroundRight.toggleClass("active", val == "right");

        if (this.backgroundBinding)
            this.backgroundBinding.toggleClass("active", val == "center");

        this.trigger("active-part-changed");
    }

    // return active part of pages : left / right 
    get activeSide() {
        if (this.displayedSide)
            return this.displayedSide;
        else
            if (this.data.isFirstPage)
                return "right";
            else
                if (this.data.isLastPage)
                    return "left";
                else
                    return this._activeSide;
    }

    set activeSide(val) {
        this._activeSide = val;
    }


    get hideLabels() {
        return this._hideLabels || this.rawDisplay;
    }

    set hideLabels(val) {
        this._hideLabels = val;
    }


    get layoutData() {
        return this._layoutData;
    }
    /**
     * - backgroundColors : show background colors buttons
     * - addText : show addText buttons
     */
    get options() {
        if (!this._options)
            this._options = {};

        return this._options;
    }

    set options(val) {
        this._options = val;
    }

    get book() {
        return this.creation;
    }

    set book(val) {
        this._creationbook = val;

        if (this.initialized && this.loaded)
            this._positionBackgrounds();
    }

    get lostBorder() {
        return this.data ? this.data.lostBorder : 0;
    }

    get extraWidth() {
        return this.page && this.page.isCover ? this.book.sliceWidth : 0;
    }

    get areaWidth() {
        if (this.displayedSide || this.activeSide == "right")
            return this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth * 2;

        if (this.displayedSide || this.activeSide == "left")
            return this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth * 2;

        return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;
    }

    get pageWidth() {
        if (fx.browser.isTablet || fx.browser.isMobile) {
            if (this.displayedSide || this.activeSide == "right")
                return this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth;

            if (this.displayedSide || this.activeSide == "left")
                return this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth;

            return this.page.isCover ? this.book.coverWidth : this.book.pageWidth;
        }
        else {
            if (this.displayedSide || this.activeSide == "right")
                return this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth;

            if (this.displayedSide || this.activeSide == "left")
                return this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth;

            return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;
        }
    }

    get stageContainerWidth() {
        if (this.displayedSide == "right")
            return this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth * 2;
        if (this.displayedSide == "left")
            return this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth * 2;

        return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;
    }

    get stageWidth() {
        if (this.displayedSide == "right")
            return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;
        if (this.displayedSide == "left")
            return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;

        return this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;
    }

    get sliceBackground() {
        let childs = this.stage.getChilds();
        let sliceBG;
        for (let i = 0; i < childs.length; i++) {
            if (childs[i] instanceof shared.stage.components.Background && childs[i].data.creation == "slice") {
                sliceBG = childs[i];
                break;
            }
        }
        return sliceBG;
    }


    /***************** Actions *****************/


    //invertScale(scale){}

    enableActions(val) {
        this._actionsEnabled = val;
    }

    displayPaginationPopup() {
        // no left pagination on the cover, the first page, or before the area is loaded
        let pagination = this.getPagination("left");
        if (pagination)
            pagination.displayPaginationPopup();
    }


    setBackground(color, side) {
        this.page.updateBackgroundColor(color, (side || this.activeSide) || "both", true);
    }


    activeOver(direction) {

    }

    addComponent(data, side, forceSide) 
    {
        if (!this.page) return;

        if (side !== undefined)
            this.activePart = side;

        this.page.addComponent(data, forceSide ? this.activeSide : (this.single ? "left" : this.activeSide), this.creation.pageWidth, this.creation.pageHeight, this.data.isCover ? this.creation.sliceWidth : 0);
    }

    onComponentAdded(event) {
        super.onComponentAdded(event);

        let component = event.detail.component;

        if (component.data.isSliceText) // let's center
        {
            component.resizeText();
            this._centerSliceComponent(component);
        }
    }

    updatePhoto(data) {
        if (!this.data) return;

        let components = this.data.photosComponents;

        if (this.activeSide)
            components = this.data.photosComponents.filter(a => (this.activeSide == "left") ?
                (fx.graphics.getBoundingRect(a, a.rotation).x < this.book.pageWidth) :
                (fx.graphics.getBoundingRect(a, a.rotation).x >= this.book.pageWidth + this.extraWidth));

        components = components.sort((a, b) => (b.width * b.height) - (a.width * a.height));

        let emptyPhotos = components.filter(a => a.content == "");

        if (emptyPhotos.length > 0) {
            emptyPhotos.sort((a, b) => a.x - b.x);
            emptyPhotos.getItemAt(0).content = data.content;
        }
        else
            if (components.length > 0)
                components.getItemAt(0).content = data.content;
            else
                this.addPhoto(data);
    }

    addPhoto(data) {
        if (data.side)
            this.activeSide = data.side;

        // if activeSide is empty
        if (this.activeSide == "") {
            // check if empty photos on double page from the left to the right
            let components = this.data.photosComponents.sort((a, b) => a.x - b.x);
            for (let i = 0; i < components.length; i++) {
                let component = components.getItemAt(i);
                if (component.content == "") {
                    component.content = data.content;
                    return;
                }
            }
            // otherwise, set activeSide to empty : which mean it will fill first page and then second one
            this.activeSide = "";
        }

        let activeSide = (this.activeSide == "") ? "left" : this.activeSide;

        let components = this.data.photosComponents.filter(a => (activeSide == "left") ?
            (fx.graphics.getBoundingRect(a, a.rotation).x < this.book.pageWidth) :
            (fx.graphics.getBoundingRect(a, a.rotation).x >= this.book.pageWidth + this.extraWidth));

        if (components.length >= fx.get("settings").numMaxPhoto && this.activeSide == "") {
            activeSide = "right";

            components = this.data.photosComponents.filter(a => (activeSide == "left") ?
                (fx.graphics.getBoundingRect(a, a.rotation).x < this.book.pageWidth) :
                (fx.graphics.getBoundingRect(a, a.rotation).x >= this.book.pageWidth + this.extraWidth));
        }

        components.sort((a, b) => a.x - b.x);

        // first find if a photo component is empty, and use it
        // otherwise find layout with enougth pics
        for (let i = 0; i < components.length; i++) {
            let component = components.getItemAt(i);
            if (component.content == "") {
                component.content = data.content;
                return;
            }
        }

        // if already max pics
        if (components.length >= fx.get("settings").numMaxPhoto) {
            // so we update biggest picture
            components.sort((a, b) => (b.width * b.height) - (a.width * a.height));
            components.getItemAt(0).content = data.content;
            return;
        }

        let photos = [];
        for (let i = 0; i < components.length; i++) {
            let component = components.getItemAt(i);
            let photo = this.model.photos.find({ id: component.content })
            if (photo)
                photos.push(photo)
        }

        let photo = this.model.photos.find({ id: data.content });
        if (photo)
            photos.push(photo)

        // the fold is on the opposite edge from the side this page sits on -- the cover folds too, on its spine
        let fold = activeSide == "left" ? "right" : activeSide == "right" ? "left" : null;
        let layouts = fx.service("LayoutsGenerator").getLayouts(photos, fold);

        if (layouts.length == 0) return;

        this.initLayoutData();

        let pageWidth = this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth;
        this.data.addPhoto(photos, activeSide, pageWidth, this.pageHeight, this.extraWidth, layouts[0]);
    }

    /***************** Overrides *****************/

    // scale changed
    refresh() {
        super.refresh();

        this.activePart = "";
        this.updateLabels();
        this.updateButtons();
    }

    load() {
        if (this.stage && this.stage.loaded && this.page == this.stage.data)
            return;

        if (!this.page)
            return;

        if (this.backgroundBinding)
            this.backgroundBinding.toggle(this.page.isCover);

        this._updateSidePositions();

        super.load();

        if (this.book.pagenumbers)
            this._updatePagination();

        this.updateChildPositions();

        this._updateBackCover();

        this.initLayoutData();
    }

    // layoutData is used when automatic layout is applied
    // - we save layouts here, so if next layout is asked, we can know which one is it
    // - we save original layout also, so we can add to list of layouts, and allow user to get it back
    // original layout if the one before user start to use auto layout button.
    // so it has to be re-initialized whenever user update page.
    initLayoutData() {
        this._layoutData = {
            left: { code: "", position: 0 },
            right: { code: "", position: 0 }
        };
    }

    getLayoutData(side) {
        return this._layoutData[side];
    }

    createOriginalLayout(side, code) {
        this._layoutData[side].originalLayout = this.data.extractLayout(side, this.book.pageWidth, this.extraWidth)
        this._layoutData[side].position = 0;
        this._layoutData[side].code = code;

        return this._layoutData[side].originalLayout;
    }


    /// --------------------- //

    _updateSidePositions() {
        if (!this.initialized || !this.page) return;

        if (this.displayedSide == "right") {
            this._realWidth = this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth * 2;

            this.width(this._realWidth);
            this.stageContainer.width(this._realWidth);
            this.stage.width(this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2);

            this.stage.left(-this.book.pageWidth);

            if (this.container) {
                this.container.left(-this.book.pageWidth + (fx.browser.isSafari ? 0.1 : 0)); // hack for safari to avoid black background
                this.container.width(this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2);
            }

            if (this.backgroundLeft) {
                this.backgroundLeft.hide();
                this.backgroundLeft.left(0);
            }

            if (this.backgroundRight) {
                this.backgroundRight.show();
                this.backgroundRight.left(this.book.pageWidth + this.book.sliceWidth);
            }

            if (this.backgroundBinding) {
                this.backgroundBinding.show();
                this.backgroundBinding.left(this.book.pageWidth);
            }

            if (this.binding) {
                this.binding.removeClass("inverted")
                this.binding.left(this.book.pageWidth)
            }

            if (this.text)
                this.text.text = this.page.label();
        }
        else
            if (this.displayedSide == "left") {
                this._realWidth = this.page.isCover ? this.book.pageWidth : this.book.pageWidth * 2;
                this.width(this._realWidth);
                this.stageContainer.width(this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth * 2);
                this.stage.width(this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2);

                if (this.container) {
                    this.container.left(fx.browser.isSafari ? 0.1 : 0); // hack for safari to avoid black background
                    this.container.width(this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2);
                }

                if (this.backgroundLeft) {
                    this.backgroundLeft.show();
                    this.backgroundLeft.left(0);
                }

                if (this.backgroundRight) {
                    this.backgroundRight.hide();
                    this.backgroundRight.left(this.book.pageWidth + this.book.sliceWidth);
                }

                if (this.backgroundBinding) {
                    this.backgroundBinding.show();
                    this.backgroundBinding.left(this.book.pageWidth);
                }

                if (this.binding) {
                    this.binding.addClass("inverted")
                    this.binding.left(this.book.pageWidth - (this.book.isBind ? 1 : 0))
                }
            }
            else {
                this._realWidth = this.page.isCover ? this.book.coverWidth : this.book.pageWidth * 2;
                this.width(this._realWidth);
                this.stageContainer.width(this._realWidth);
                this.stage.width(this._realWidth);

                this.stage.left(0);

                if (this.container) {
                    this.container.left(0);
                    this.container.width(this._realWidth);
                }

                if (this.backgroundLeft) {
                    this.backgroundLeft.show();
                    this.backgroundLeft.left(0);
                }

                if (this.backgroundRight) {
                    this.backgroundRight.show();
                    this.backgroundRight.left(this.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth);
                }

                if (this.backgroundBinding) {
                    if (!this.page.isCover)
                        this.backgroundBinding.hide();

                    this.backgroundBinding.left(this.book.pageWidth);
                }

                if (this.binding) {
                    this.binding.removeClass("inverted")
                    this.binding.left(this._realWidth / 2);
                }
            }
    }

    unload() {
        if (!this.loaded)
            return;

        super.unload();

        this.activePart = "";
    }

    create() {
        super.create();

        if (!this.rawDisplay) {
            this.lostBorderTop = new fx.components.Box("lostborder");
            this.lostBorderTop.pointerEvents = true;
            this.lostBorderTop.toolTip = fx.text("Marge de découpe");
            this.stageContainer.addChild(this.lostBorderTop, { top: 0, left: 0, width: "100%", height: this.LOSTBORDER });

            this.lostBorderLeft = new fx.components.Box("lostborder");
            this.lostBorderLeft.pointerEvents = true;
            this.lostBorderLeft.toolTip = fx.text("Marge de découpe");
            this.stageContainer.addChild(this.lostBorderLeft, { top: this.LOSTBORDER, bottom: this.LOSTBORDER, left: 0, width: this.LOSTBORDER });

            this.lostBorderRight = new fx.components.Box("lostborder");
            this.lostBorderRight.toolTip = fx.text("Marge de découpe");
            this.lostBorderRight.pointerEvents = true;
            this.stageContainer.addChild(this.lostBorderRight, { top: this.LOSTBORDER, bottom: this.LOSTBORDER, right: 0, width: this.LOSTBORDER });

            this.lostBorderBottom = new fx.components.Box("lostborder");
            this.lostBorderBottom.pointerEvents = true;
            this.lostBorderBottom.toolTip = fx.text("Marge de découpe");
            this.stageContainer.addChild(this.lostBorderBottom, { bottom: 0, left: 0, width: "100%", height: this.LOSTBORDER });
        }

        if (!this.rawDisplay) {
            this.container = new fx.components.Box("Container");
            this.addChild(this.container, { width: "100%", height: "100%" });

            // backgrounds
            this.backgroundLeft = new fx.components.Box("background-left");
            this.backgroundLeft.pointerEvents = false;
            this.container.addChild(this.backgroundLeft);

            this.backgroundRight = new fx.components.Box("background-right");
            this.backgroundRight.pointerEvents = false;
            this.container.addChild(this.backgroundRight);

            this.backgroundBinding = new fx.components.Box("background-binding", { "background-color": "transparent" });
            this.backgroundBinding.pointerEvents = false;
            this.container.addChild(this.backgroundBinding);

            this.binding = new shared.stage.CoverBinding(this.book, this.data);
            this.binding.visibleAtStart = (this.book.isSpiral || this.book.isBind);
            this.container.addChild(this.binding, { left: "center", top: 0, width: this.book.sliceWidth, height: "100%" });
        }

        if (!this.hideLabels) {
            if (!this.data.isCover) {
                this._pagesButtonContainer = new fx.components.Box();
                this._pagesButtonContainer.visibleAtStart = false;
                this.addChild(this._pagesButtonContainer, { height: 40, width: fx.browser.isTablet ? 54 : 40, left: 0, bottom: -45 });

                this.removePagesButton = new fx.components.IconButton({ className: "action removePagesButton", icon: fx.assets.removeIcon });
                this._pagesButtonContainer.addChild(this.removePagesButton, { height: fx.browser.isTablet ? 54 : 40, width: fx.browser.isTablet ? 54 : 40, right: 0 });
            }

            this.text = new fx.components.Text({ text: this.page.label(this.displayedSide), className: "label" });
            this.text.visibleAtStart = false;
            this.addChild(this.text, { left: "center", width: "auto", height: 18 });

            this.textRight = new fx.components.Text({ text: this.page.label("right"), className: "label right" });
            this.textRight.visibleAtStart = false;
            this.addChild(this.textRight, { right: fx.browser.isDesktop ? 0 : 5, width: "auto", height: 18 });


            if (!this.page.isCover && !this.book.is3d) {
                if (!this.page.isLastPage && this._layoutAuto) {
                    this.layoutAutoRight = new fx.components.Image({ data: fx.get("assets").layoutAuto, className: "layout-auto" });
                    this.layoutAutoRight.toolTip = fx.text("Mise en page aléatoire");
                    this.layoutAutoRight.visibleAtStart = false;
                    this.addChild(this.layoutAutoRight, { right: 0, width: 20, height: 20 });
                }

                if (!this.page.isFirstPage && this._layoutAuto) {
                    this.layoutAutoLeft = new fx.components.Image({ data: fx.get("assets").layoutAuto, className: "layout-auto" });
                    this.layoutAutoLeft.toolTip = fx.text("Mise en page aléatoire");
                    this.layoutAutoLeft.visibleAtStart = false;
                    this.addChild(this.layoutAutoLeft, { left: 0, width: 20, height: 20 });
                }
            }

            this.textLeft = new fx.components.Text({ text: this.page.label("left"), className: "label left" });
            this.textLeft.visibleAtStart = false;
            this.addChild(this.textLeft, { left: fx.browser.isDesktop ? 0 : 5, width: "auto", height: 18 });

            this.optionsContainerLeft = new fx.components.HBox("optionsContainer");
            this.optionsContainerRight = new fx.components.HBox("optionsContainer");

            if (this.options.backgroundColors) {
                if (!this.data.hasbackcover || this.data.isLastPage) {
                    this.addBackgroundColorLeft = new fx.components.ColorPickerButton({ direction: "top", lastColors: (this.model && this.model.customcolors) ? this.model.customcolors : null });
                    this.addBackgroundColorLeft.toolTip = fx.text("Modifier la couleur de fond");
                    this.optionsContainerLeft.addChild(this.addBackgroundColorLeft, { width: 30, height: 30 });
                }

                if (!this.data.hasbackcover || this.data.isFirstPage) {
                    this.addBackgroundColorRight = new fx.components.ColorPickerButton({ direction: "top", lastColors: (this.model && this.model.customcolors) ? this.model.customcolors : null });
                    this.addBackgroundColorRight.toolTip = fx.text("Modifier la couleur de fond");
                    this.optionsContainerRight.addChild(this.addBackgroundColorRight, { width: 30, height: 30 });
                }
            }

            if (this.options.addText) {
                if (!this.data.hasbackcover || this.data.isLastPage) {
                    this.addTextLeft = new fx.components.IconButton({ icon: fx.get("assets").addText, iconRatio: 0.8, className: "addText" });
                    this.addTextLeft.toolTip = fx.text("Ajouter du texte");
                    this.optionsContainerLeft.addChild(this.addTextLeft, { width: 30, height: 30 });
                }

                if (!this.data.hasbackcover || this.data.isFirstPage) {
                    this.addTextRight = new fx.components.IconButton({ icon: fx.get("assets").addText, iconRatio: 0.8, className: "addText" });
                    this.addTextRight.toolTip = fx.text("Ajouter du texte");
                    this.optionsContainerRight.addChild(this.addTextRight, { width: 30, height: 30 });
                }
            }

            if (this.optionsContainerLeft.getChilds().length > 0)
                this.container.addChild(this.optionsContainerLeft, { width: "auto", height: "30", left: 0 });

            if (this.optionsContainerRight.getChilds().length > 0)
                this.container.addChild(this.optionsContainerRight, { width: "auto", height: "30", right: 0 });

            this.optionsContainerRight.addClass("action");
            this.optionsContainerLeft.addClass("action");
        }
    }

    _positionBackgrounds() {
        if (!this.book)
            return;

        if (this.backgroundLeft)
            this.backgroundLeft.viewport({ left: 0, top: 0, width: this.book.pageWidth, height: "100%" });

        if (this.backgroundRight)
            this.backgroundRight.viewport({ left: this.book.pageWidth + (this.page && this.page.isCover ? this.book.sliceWidth : 0), top: 0, width: this.book.pageWidth, height: "100%" });

        if (this.backgroundBinding)
            this.backgroundBinding.viewport({ left: this.book.pageWidth, top: 0, width: this.book.sliceWidth, height: "100%" });
    }

    onReady() {
        super.onReady();

        this._positionBackgrounds();

        if (this.addBackgroundColorLeft)
            this.on("color", this.onColorLeft, this.addBackgroundColorLeft);

        if (this.addBackgroundColorRight)
            this.on("color", this.onColorRight, this.addBackgroundColorRight);

        if (this.addTextLeft)
            this.on("click", this.onAddTextLeft, this.addTextLeft);

        if (this.addTextRight)
            this.on("click", this.onAddTextRight, this.addTextRight);

        if (this.layoutAutoLeft)
            this.on("click", this.onLayoutAutoLeft, this.layoutAutoLeft);

        if (this.layoutAutoRight)
            this.on("click", this.onLayoutAutoRight, this.layoutAutoRight);

        if (this.removePagesButton)
            this.on("click", this.onDeletePage, this.removePagesButton);

        this._updateLayoutButtons();

    }

    onColorLeft(e) {
        this.page.updateBackgroundColor(e.detail, "left", true);
    }

    onColorRight(e) {
        this.page.updateBackgroundColor(e.detail, "right", true);
    }

    onAddTextLeft() {
        this.book.event("add-component", {
            component_type: "text",
            content: "text",
            creation: "manual",
            area: this,
            side: "left"
        });
    }

    onAddTextRight() {
        this.book.event("add-component", {
            component_type: "text",
            content: "text",
            creation: "manual",
            area: this,
            side: "right"
        });
    }

    onLayoutAutoLeft() {
        this.book.event("layout-auto", { side: "left", area: this });
    }

    onLayoutAutoRight() {
        this.book.event("layout-auto", { side: "right", area: this });
    }

    updateDisplay() {
        this.resize();
        this.position();

        this._updateSidePositions();

        if (this.text)
            this.text.hide();

        if (this.textRight)
            this.textRight.hide();

        if (this.layoutAutoLeft)
            this.layoutAutoLeft.hide();

        if (this.layoutAutoRight)
            this.layoutAutoRight.hide();

        if (this.textLeft)
            this.textLeft.hide();

        this.updateChildPositions();

        this.onDisplayUpdated();
    }

    updateButtons() {
        if (this._pagesButtonContainer) {
            this._pagesButtonContainer.css("transform", "scale(" + (1 / this.scale) + ")");
            this._pagesButtonContainer.left((this.stageWidth) / 2 - (this._pagesButtonContainer.width() / 2 / this.scale));
        }

        // hide button in global view
        if (this.model.zoom.value < 100 && fx.browser.isDesktop) {
            if (this._pagesButtonContainer)
                this._pagesButtonContainer.hide();
        }
        else if (this.model.zoom.value == 100 || !fx.browser.isDesktop) {
            if (this._pagesButtonContainer)
                this._pagesButtonContainer.toggle(!this.data.isCover);
        }

        // disable button if no more pages can be added
        if (this._pagesButtonContainer) {
            if (this.book.canRemove) {
                if (this.removePagesButton) {
                    this.removePagesButton.toolTip = fx.text("Supprimer 2 pages");
                    this.removePagesButton.removeClass("click-disabled");
                }
            }
            else {
                if (this.removePagesButton) {
                    this.removePagesButton.toolTip = fx.text("Votre album ne peut contenir moins de $ pages", this.book.minPages);
                    this.removePagesButton.addClass("click-disabled");    // fake disable for allowing tooltip on hover
                }
            }
        }
    }

    updateLabels() {
        if (!this.loaded) return;

        if (this.hideLabels) {
            if (this.text)
                this.text.hide();

            if (this.textRight)
                this.textRight.hide();

            if (this.layoutAutoLeft)
                this.layoutAutoLeft.hide();

            if (this.layoutAutoRight)
                this.layoutAutoRight.hide();

            if (this.textLeft)
                this.textLeft.hide();

            if (this.optionsContainerLeft)
                this.optionsContainerLeft.hide();

            if (this.optionsContainerRight)
                this.optionsContainerRight.hide();

        }
        else {
            this.text.css("transform", "scale(" + (1 / this.scale) + ")");
            this.textLeft.css("transform", "scale(" + (1 / this.scale) + ")");
            this.textRight.css("transform", "scale(" + (1 / this.scale) + ")");

            if (this.layoutAutoLeft)
                this.layoutAutoLeft.css("transform", "scale(" + (1 / this.scale) + ")");
            if (this.layoutAutoRight)
                this.layoutAutoRight.css("transform", "scale(" + (1 / this.scale) + ")");

            this.text.left("center");
            this.text.top(this.realHeight + (fx.browser.isDesktop || fx.browser.isTablet ? 15 : 10) / this.scale);
            this.textLeft.top(this.realHeight + (fx.browser.isDesktop || fx.browser.isTablet ? 15 : 10) / this.scale);
            this.textRight.top(this.realHeight + (fx.browser.isDesktop || fx.browser.isTablet ? 15 : 10) / this.scale);

            if (this.layoutAutoLeft) {
                this.layoutAutoLeft.top(this.realHeight + (fx.dom.height(this.text.node) / this.scale));
                this.layoutAutoLeft.left(15 + (fx.dom.width(this.textLeft.node) / this.scale));
            }

            if (this.layoutAutoRight) {
                this.layoutAutoRight.top(this.realHeight + (fx.dom.height(this.text.node) / this.scale));
                this.layoutAutoRight.right(10 + (fx.dom.width(this.textRight.node) / this.scale));
            }

            this.optionsContainerLeft.css("transform", "scale(" + (1 / this.scale) + ")");
            this.optionsContainerLeft.top(this.realHeight + 5);
            this.optionsContainerLeft.left(this.book.pageWidth / 2);

            this.optionsContainerRight.css("transform", "scale(" + (1 / this.scale) + ")");
            this.optionsContainerRight.top(this.realHeight + 5);
            this.optionsContainerRight.left(this.book.pageWidth + this.extraWidth + this.book.pageWidth / 2 - fx.dom.width(this.optionsContainerRight.node) / 2);

            if (this._labelStyle == "double") {
                this.text.hide();
                this.textRight.show();

                if (this.layoutAutoLeft)
                    this.layoutAutoLeft.show();
                if (this.layoutAutoRight)
                    this.layoutAutoRight.show();

                this.textLeft.show();
                this.optionsContainerLeft.show();
                this.optionsContainerRight.show();
            }
            else
                if (this.model.zoom.value < 100) {
                    this.text.show();
                    this.textRight.hide();
                    if (this.layoutAutoLeft)
                        this.layoutAutoLeft.hide();
                    if (this.layoutAutoRight)
                        this.layoutAutoRight.hide();
                    this.textLeft.hide();
                    this.optionsContainerLeft.hide();
                    this.optionsContainerRight.hide();
                }
                else
                    if (this.model.zoom.value == 100) {
                        if (this.single) {
                            this.text.show();
                            this.textRight.hide();
                            if (this.layoutAutoLeft)
                                this.layoutAutoLeft.hide();
                            if (this.layoutAutoRight)
                                this.layoutAutoRight.hide();
                            this.textLeft.hide();
                            this.optionsContainerLeft.hide();
                            this.optionsContainerRight.hide();
                        }
                        else {
                            this.text.hide();
                            this.textRight.show();
                            if (this.layoutAutoLeft)
                                this.layoutAutoLeft.show();
                            if (this.layoutAutoRight)
                                this.layoutAutoRight.show();

                            this.textLeft.show();
                            this.optionsContainerLeft.show();
                            this.optionsContainerRight.show();
                        }
                    }
                    else {
                        this.text.hide();
                        this.textRight.hide();
                        if (this.layoutAutoLeft)
                            this.layoutAutoLeft.hide();
                        if (this.layoutAutoRight)
                            this.layoutAutoRight.hide();
                        this.textLeft.hide();
                        this.optionsContainerLeft.hide();
                        this.optionsContainerRight.hide();
                    }
        }
    }

    updateChildPositions() {
        if (!this.loaded) return;

        this.updateLabels();
        this.updateButtons();
    }



    /***************** Events *****************/

    onDataEvent(event) {
        super.onDataEvent(event);

        switch (event.type) {
            case "cover-updated":

                if (!this.initialized) return;

                this._positionBackgrounds();

                if (this.binding) {
                    this.binding.width(this.book.sliceWidth);
                    this.binding.toggle(this.book.isSpiral || (this.book.isBind && this.data.isCover))
                }

                this.width(this.areaWidth);
                this.stageContainer.width(this.stageContainerWidth);
                this.stage.width(this.stageWidth);

                if (this.container)
                    this.container.updateDisplay();

                this.updateDisplay();

                if (this.stage.loaded)
                    for (let i = 0; i < this._childs.length; i++)
                        if (this.stage._childs[i])
                            this.stage._childs[i].onDisplayUpdated();
                break;
        }
    }


    onDataUpdated(action) {
        super.onDataUpdated(action);

        if (action.impacts("number"))
            this._updateTexts();

        if (action.impacts("number") || action.impacts("pagenumbers_textcolor") || action.impacts("pagenumbers_bgcolor") || action.impacts("pagenumbers_fontsize") || action.impacts("pagenumbers_fontfamily"))
            this._refreshPagination();

        if (action.impacts("pagenumbers"))
            this._updatePagination();

        if (action.impacts("hasbackcover"))
            this._updateBackCover();

        if (action.type == "addItem" || action.type == "addItemAt" || action.type == "removeItem") {
            this.delay(this._updateLayoutButtons, 250);
        }

    }


    onChildUpdated(action) {
        super.onChildUpdated(action);

        if (action.impacts("x", "y", "width", "height"))
            this.delay(this._updateLayoutButtons, 250);
        else
            if (action.model && action.model.content_type == "slice-text" && action.impacts("content")) // need to center
                this.delay(this._centerSliceText);
    }

    _centerSliceText() {
        if (!this.data.sliceText)
            return;

        let component = this.getChildFromData(this.data.sliceText);
        if (component) {
            component._calculateTextSize();
            this._centerSliceComponent(component);
        }

    }

    _centerSliceComponent(component) {
        // TODO : improve (move to SliceEditorPopup ?)
        component.data.update("move", {
            x: (this.model.creation.coverWidth - component.data.height) / 2 + (component.rotation == 90 ? component.data.height : 0),
            height: component.acceptedSize.height
        });
    }

    _updateLayoutButtons() {
        let photosComponents = this.data.photosComponents;
        let area = this;
        let pageWidth = this.book.pageWidth;

        if (this.layoutAutoLeft) {
            let leftComponents = photosComponents.filter(function (a) {
                let bounding = fx.graphics.getBoundingRect(a, a.rotation);
                return /*a.content != "" &&*/ (bounding.x < pageWidth);
            });

            if (leftComponents.length > 0)
                this.layoutAutoLeft.removeClass("hide");
            else
                this.layoutAutoLeft.addClass("hide");
        }

        if (this.layoutAutoRight) {
            let rightComponents = photosComponents.filter(function (a) {
                let bounding = fx.graphics.getBoundingRect(a, a.rotation);
                return (bounding.x >= pageWidth + area.extraWidth);
            });

            if (rightComponents.length > 0)
                this.layoutAutoRight.removeClass("hide");
            else
                this.layoutAutoRight.addClass("hide");
        }
    }

    onDeletePage() {
        this.data.event("remove-page", this.page);
    }

    _updateTexts() {
        if (this.text)
            this.text.text = this.page.label();

        if (this.textRight)
            this.textRight.text = this.page.label("right");

        if (this.textLeft)
            this.textLeft.text = this.page.label("left");
    }

    _updateBackCover() {
        if (!this.data || !this.backgroundLeft || !this.backgroundRight || this.rawDisplay)
            return;

        this.backgroundLeft.toggleClass("backcover", !!(this.data.hasbackcover && this.data.isFirstPage));
        this.backgroundRight.toggleClass("backcover", !!(this.data.hasbackcover && this.data.isLastPage));

        if (this.data.hasbackcover) {
            let viewport = { top: "center", left: this.data.isFirstPage ? 0 : this.width() / 2, width: this.width() / 2 };

            if (!this.backCoverText && this.data.hasbackcover) {
                this.backCoverText = new fx.components.Text({ text: fx.text("Intérieur de couverture<br> non imprimable"), className: "backcover" });
                this.container.addChild(this.backCoverText, viewport);
            }
            else
                this.backCoverText.viewport = viewport;
        }
        else {
            if (this.backCoverText) {
                this.backCoverText.destroy();
                this.backCoverText = null;
            }
        }
    }

    selectActivePart(e) {
        if (!this.stage || !this.stage.node) return;

        // if on mobile event contains "center" parameter for position
        // otherwise on desktop, it contains pageX, pageY
        let position = e.center || { x: e.pageX, y: e.pageY };

        let offset = fx.graphics.globalToLocal(this.stage.node, position.x, position.y)

        offset.x = offset.x / this.scale;

        let pageWidth = this.data.isCover ? ((this.book.coverWidth - this.book.sliceWidth) / 2) : this.book.pageWidth;

        if (fx.dom.parent(e.target, ".Area") && !fx.dom.parent(e.target, ".PageTools")) {
            if (fx.dom.parent(e.target, ".Stage") && fx.dom.parent(e.target, this.node) && this.page.hasbackcover)
                this.activePart = (this.page.isFirstPage) ? "right" : "left";
            else
                if (!fx.dom.parent(e.target, this.node))
                    this.activePart = "";
                else
                    if (offset.x < pageWidth) {
                        this.activePart = "left";
                    }
                    else
                        if (offset.x > pageWidth && offset.x < pageWidth + (this.page.isCover ? this.book.sliceWidth : 0)) {
                            this.activePart = "center";
                        }
                        else {
                            this.activePart = "right";
                        }
        }
        else
            if (fx.dom.parent(e.target, ".Board"))
                this.activePart = "";
    }

    // ----------------- Pagination ---------------//
    _getPageSideNumber(side) {
        let pageNumber;
        try {
            pageNumber = this.data.label().split("-");
        }
        catch {
            pageNumber = [];
            pageNumber[0] = this.data.label();
            pageNumber[1] = this.data.label();
        }
        if (pageNumber.length > 1) {
            if (side == "left")
                pageNumber = pageNumber[0];
            else
                pageNumber = pageNumber[1];
        }
        return pageNumber;
    }

    _updatePagination() {
        if (!this.loaded) return;

        let leftPagination = this.getPagination("left");
        let rightPagination = this.getPagination("right");

        if (this.book.pagenumbers) {
            if (!leftPagination)
                this._addPagination("left");

            if (!rightPagination)
                this._addPagination("right");
        }
        else {
            if (leftPagination)
                leftPagination.destroy();

            if (rightPagination)
                rightPagination.destroy();
        }
    }

    _refreshPagination() {
        let leftPagination = this.getPagination("left");
        let rightPagination = this.getPagination("right");

        if (leftPagination) {
            leftPagination.refresh(this.book.pagenumbers_textcolor, this.book.pagenumbers_bgcolor, this.book.pagenumbers_fontsize, this.book.pagenumbers_fontfamily, this._getPageSideNumber("left"));
            leftPagination.setPosition(this.realWidth, this.realHeight);
        }

        if (rightPagination) {
            rightPagination.refresh(this.book.pagenumbers_textcolor, this.book.pagenumbers_bgcolor, this.book.pagenumbers_fontsize, this.book.pagenumbers_fontfamily, this._getPageSideNumber("right"));
            rightPagination.setPosition(this.realWidth, this.realHeight);
        }
    }

    _addPagination(side) {
        if (!this.data.isCover) {
            if (side == "left" && !this.data.isFirstPage)
                this.addComponent(this.data.getPagination("left", this.book.pagenumbers_textcolor, this.book.pagenumbers_bgcolor, this.book.pagenumbers_fontsize, this.book.pagenumbers_fontfamily));
            else
                if (side == "right" && !this.data.isLastPage)
                    this.addComponent(this.data.getPagination("right", this.book.pagenumbers_textcolor, this.book.pagenumbers_bgcolor, this.book.pagenumbers_fontsize, this.book.pagenumbers_fontfamily));
        }
    }

    getPagination(side) {
        if (!this.stage) return;

        let pagination;
        let childs = this.stage.getChilds();
        for (let i = 0; i < childs.length; i++) {
            let child = childs.getItemAt(i);
            if (child instanceof shared.stage.components.Pagination) {
                if (child.data.side == side) {
                    pagination = child;
                    break;
                }
            }
        }
        return pagination;
    }

});